import React from "react"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import Checkbox from "@mui/material/Checkbox"
import ListItemText from "@mui/material/ListItemText"
import Chip from "@mui/material/Chip"
import Box from "@mui/material/Box"
import { makeStyles } from "@mui/styles"
import { KFC_BRANDS } from "../../utils"
import CloudinaryImage from "../Image/CloudinaryImage"

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const LOGO_SIZE = 16

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}

const useStyles = makeStyles({
    logo: {
        width: 16,
        marginBottom: -4
    },
    chip: {
        height: "auto",
    },
})

const sx = {
    logoWrapper: {
        width: LOGO_SIZE,
        height: LOGO_SIZE,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        mr: 1,
        verticalAlign: "middle",
    },
    logoInitials: {
        width: LOGO_SIZE,
        height: LOGO_SIZE,
        borderRadius: 1,
        border: "1px solid",
        borderColor: "divider",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 8,
        fontWeight: 500,
        color: "text.secondary",
        flexShrink: 0,
        mr: 1,
        verticalAlign: "middle",
    },
}

const getInitials = (label) => (label || "").replace(/[^A-Za-zÀ-ÿ]/g, "").slice(0, 2).toUpperCase()

const OptionLogo = (props) => {
    const { option, isEnterprise, logoClassName } = props

    if (option.image) {
        return <img className={logoClassName} src={option.image} alt={`Logo ${option.label}`} />
    }

    if (option.logo && option.logo.publicId) {
        return (
            <Box sx={sx.logoWrapper}>
                <CloudinaryImage imageId={option.logo.publicId} width={LOGO_SIZE} height={LOGO_SIZE} resize="fit" />
            </Box>
        )
    }

    if (isEnterprise) {
        return <Box component="span" sx={sx.logoInitials}>{getInitials(option.label)}</Box>
    }

    return null
}

const BrandsSelect = (props) => {
    const { classes, productBrands, enterpriseOptions = [], value, noLabel,fullWidth = false, label = "Marques", error, ...otherProps } = props

    const currentClasses = useStyles()
    const resolveOption = (val) => KFC_BRANDS.find(elem => elem.name === val) || enterpriseOptions.find(elem => elem.name === val)
    const allOptions = [...productBrands, ...enterpriseOptions]
    const enterpriseNames = new Set(enterpriseOptions.map(elem => elem.name))
    const logoClassName = classes ? classes.logo : currentClasses.logo

    return (
        <FormControl className={classes?.formControl} fullWidth={fullWidth} variant="standard" error={!!error}>
            <InputLabel>{label}</InputLabel>
            <Select
                variant="standard"
                multiple={true}
                name="brand"
                label="Marque"
                id="brand"
                {...otherProps}
                fullWidth
                renderValue={selected => (
                    <div className={classes?.chips}>
                        {
                            selected.includes("ALL") &&
                            productBrands.find(elem => elem.name === "ALL").label
                        }
                        {
                            !selected.includes("ALL") &&
                            selected.map(value => {
                                const option = resolveOption(value)

                                if (!option) {
                                    return null
                                }

                                return <Chip
                                    key={value}
                                    label={(
                                        <>
                                            <OptionLogo
                                                option={option}
                                                isEnterprise={enterpriseNames.has(option.name)}
                                                logoClassName={logoClassName}
                                            />
                                            {
                                                !noLabel &&
                                                option.label
                                            }
                                        </>
                                        )}
                                    className={classes?.chip ? classes.chip : currentClasses.chip}
                                />
                            })
                        }
                    </div>
                )}
                value={value}
                MenuProps={MenuProps}
            >
                {
                    allOptions.map(elem =>
                        <MenuItem key={elem.name} value={elem.name}>
                            <Checkbox checked={value.indexOf(elem.name) > -1 || (!enterpriseNames.has(elem.name) && value.includes("ALL"))}  color="secondary" />
                            <ListItemText primary={(
                                <>
                                    <OptionLogo
                                        option={elem}
                                        isEnterprise={enterpriseNames.has(elem.name)}
                                        logoClassName={logoClassName}
                                    />
                                    {elem.label}
                                </>
                                )}
                            />
                        </MenuItem>
                    )
                }
            </Select>
        </FormControl>
    )
}

export default BrandsSelect
